<template>
  <div v-if="proforma">
    <v-app>
      <div class="dashboard-main-content" v-if="proforma">
        <div class="container-fluid">
          <div class="row">
            <div class="col-lg-12">
              <form id="agencyDetailFrom">
                <div class="form-box">
                  <div class="form-content pb-2">
                    <div class="d-flex align-items-center justify-content-end p-3">
                      <h3 class="title"><br></h3>
                      <button
                          @click="convertToInvoice"
                          :disabled="!(proforma.agencyInvoices.filter((a)=> a.status == 'new').length == 0 &&
                                    proforma.agencyInvoices.filter((a)=> a.status == 'paid').length != 1)"
                              class="theme-btn" style="margin-right: 10px !important;"
                          type="button">Proformayı Faturaya Çevir</button>
                      <button
                          @click="payInvoice"
                          :disabled="!(proforma.agencyInvoices.filter((a)=> a.status == 'new').length > 0)"
                          class="theme-btn" type="button">Proformayı Öde</button>
                    </div>
                  <div class="row justify-content-between">
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title mb-3">Proforma</h3>
                          <div class="card-item row p-2 pl-3">
                            <label class="label-text">Acente : {{proforma.agency.name}} </label>
                          </div>
                          <div class="card-item row p-2 pl-3">
                            <label class="label-text">Proforma Üretilme Tarihi : {{proforma.agencyProforma.createDate | ddMMyyyyHHmmSS}} </label>
                          </div>
                          <div class="card-item row p-2 pl-3">
                            <label class="label-text">Fatura Üretilme Tarihi :<span v-for="agencyInvoice in proforma.agencyInvoices"> {{agencyInvoice.createDate | ddMMyyyyHHmmSS}}, </span> </label>
                          </div>
<!--                          <div class="input-box d-flex align-items-center">-->
<!--                            <label class="label-text">Web Servis Erişimi</label>-->
<!--                            <input class="form-control " style="width: 5rem;" type="checkbox" v-model="agency.webServiceAccess">-->
<!--                          </div>-->
<!--                          <div class="input-box d-flex align-items-center">-->
<!--                            <label class="label-text">Parçalı Ödeme İmkanı</label>-->
<!--                            <input class="form-control" style="width: 5rem;" type="checkbox" v-model="agency.canTakePartialPayment">-->
<!--                          </div>-->
<!--                          <div class="input-box d-flex align-items-center">-->
<!--                            <label class="label-text">Çoklu Oda seçimi</label>-->
<!--                            <input class="form-control" style="width: 5rem;" type="checkbox" v-model="agency.canBookMultipleRooms">-->
<!--                          </div>-->
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="card-item p-3">
                        <div class="contact-form-action">
                          <h3 class="title mb-3">Belgeler</h3>
                          <div class="card-item row p-2 pl-3">
                            <label class="label-text">Proformayı İndir :
                              <span class="clickable-text" @click="downloadProforma(proforma.agencyProforma.documentStoreId)">
                                {{proforma.agencyProforma.invoiceId}}
                              </span>

                            </label>
                          </div>
                          <div class="card-item row p-2 pl-3" v-if="proforma.agencyInvoices && proforma.agencyInvoices.length > 0">
                            <label class="label-text">Faturayı indir :
                              <span v-for="agencyInvoice in proforma.agencyInvoices" class="clickable-text"
                                    @click="downloadInvoice(agencyInvoice.documentStoreId)">
                                {{agencyInvoice.invoiceId}}
                              </span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <label>
                    Rezervasyonlar
                  </label>
                      <div class="col-lg-12">
                        <div class="card-item p-3">
                          <agency-booking-list :booking-list="bookingList"></agency-booking-list>
                        </div>
                      </div>
                      <div class="col-lg-12">
                        <div class="card-item p-3">
                          <agency-invoice-list :invoice-list="proforma.agencyInvoices"></agency-invoice-list>
                        </div>
                      </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </v-app>
    <pay-invoice-popup :invoices="proforma.agencyInvoices"/>
  </div>
</template>

<script>

import AgencyBookingList from "./AgencyBookingList";
import AgencyTransactionList from "./AgencyTransactionList";
import AgencyCredit from "./agencyCredit";
import AgencyUserList from "./AgencyUserList";
import AgencyUserDetail from "./AgencyUserDetail";
import BaseEditInput from "../base/BaseEditInput";
import validationFormUtils from "../../util/validationFormUtils";
import BaseSelectInput from "../base/BaseSelectInput";
import messagePopupManager from "../../util/messagePopupManager";
import AgencyPaymentsList from "./AgencyPaymentsList";
import BaseTextAreaInput from "../base/BaseTextAreaInput";
import {ddMMyyyyHHmmSS} from "../../util/filters";
import AgencyInvoiceList from "./AgencyInvoiceList.vue";
import PayInvoicePopup from "../booking/PayInvoicePopup.vue";
export default {
  name: "ProformaDetail",
  components: {
    PayInvoicePopup,
    AgencyInvoiceList,
    BaseTextAreaInput,
    AgencyPaymentsList,
    BaseSelectInput,
    BaseEditInput, AgencyUserDetail, AgencyUserList, AgencyCredit, AgencyTransactionList, AgencyBookingList
  },
  data:function (){
    return{}
  },
  props : {
    bookingList: null,
    proforma: null,
  },
  computed:{
    agency:{
      get(){
        return this.$store.getters.getAgency;
      },
    },
    agencyCommissionRates:{
      get(){
        return this.$store.getters.getAgencyCommissionRates;
      },
    },
    user:{
      get(){
        return this.$store.getters.getAgencyUser;
      },
    },
    userList:{
      get(){
        return this.$store.getters.getAgencyUserList;
      },
    },
    marketList:{
      get(){
        return this.$store.getters.getMarketList;
      }
    },
    projectName:{
      get() {
        return this.$store.getters.getProjectName;
      }
    }
  },
  methods:{
    payInvoice(){
      $("#payInvoiceModal").modal("show");
    },
    downloadProforma(id){
      this.$store.dispatch("downloadProforma", {id});
    },
    downloadInvoice(id){
      this.$store.dispatch("downloadInvoice", {id});
    },
    convertToInvoice(){
      this.$store.dispatch("generateInvoiceFromProforma",this.proforma.proformaId).then(()=>{
        window.location.reload();
      })
    },
    ddMMyyyyHHmmSS,
  }
}
</script>

<style scoped>

.clickable-text {
  color: blue !important;
  text-decoration: underline !important;
  cursor: pointer !important;
}

button:disabled {
  background-color: #ccc !important; /* Gri arka plan */
  color: #666 !important; /* Daha soluk metin rengi */
  cursor: not-allowed !important; /* Yasak işareti */
  opacity: 0.6 !important; /* Hafif şeffaflık */
}

</style>